import React from 'react';
import Icon from '../../../components/AppIcon';

const PipelineVelocity = ({ data }) => {
  const stages = [
    { key: 'lead', label: 'Lead', icon: 'Users', color: 'bg-[#E6F0F5]', iconColor: 'text-[#002B45]' },
    { key: 'qualified', label: 'Qualified', icon: 'UserCheck', color: 'bg-[#D1F5F0]', iconColor: 'text-[#1FB5A5]' },
    { key: 'proposal', label: 'Proposal', icon: 'FileText', color: 'bg-purple-50', iconColor: 'text-purple-600' },
    { key: 'negotiation', label: 'Negotiation', icon: 'Handshake', color: 'bg-orange-50', iconColor: 'text-orange-600' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-elevation-1 p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-foreground mb-1">Pipeline Velocity</h3>
          <p className="text-sm text-muted-foreground">Average days in each stage</p>
        </div>
        <div className="w-10 h-10 bg-[#E6F0F5] rounded-lg flex items-center justify-center">
          <Icon name="Zap" size={20} className="text-[#002B45]" />
        </div>
      </div>

      <div className="space-y-4">
        {stages?.map((stage, index) => {
          const days = data?.[stage?.key] || 0;
          const maxDays = 30;
          const percentage = Math.min((days / maxDays) * 100, 100);

          return (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <div className={`w-8 h-8 ${stage?.color} rounded-lg flex items-center justify-center`}>
                    <Icon name={stage?.icon} size={16} className={stage?.iconColor} />
                  </div>
                  <span className="text-sm font-medium text-foreground">{stage?.label}</span>
                </div>
                <span className="text-sm font-bold text-foreground">{days} days</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-gradient-to-r from-teal-400 to-teal-600 h-2 rounded-full transition-all duration-500"
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="Info" size={16} className="text-muted-foreground" />
          <span className="text-sm font-medium text-foreground">Pipeline Insights</span>
        </div>
        <p className="text-xs text-muted-foreground">
          Faster pipeline velocity indicates efficient sales processes. Monitor stage durations to identify bottlenecks.
        </p>
      </div>
    </div>
  );
};

export default PipelineVelocity;